import { Directive, ElementRef, HostBinding, OnInit, OnDestroy, Input } from '@angular/core';
@Directive({
    selector: '[veeFadeInOnScroll]',
    standalone: false
})
export class FadeInOnScrollDirective implements OnInit, OnDestroy {

  @HostBinding('style.opacity') opacity = '0';
  @HostBinding('style.transition') transition = 'opacity 1s ease-out';

  @Input('appFadeInOnScroll') visibilityThreshold: number = 0.1;

  private observer!: IntersectionObserver;

  constructor(private el: ElementRef) { }

  ngOnInit() {
    this.createObserver();
  }

  ngOnDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  private createObserver() {
    const options = {
      root: null,
      threshold: this.visibilityThreshold
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.opacity = '1';
          this.observer.unobserve(this.el.nativeElement);
        }
      });
    }, options);

    this.observer.observe(this.el.nativeElement);
  }
}